export default class ProcessStepResult {
  id = null;

  step = null;
  name = "";
  description = "";

  answer = "";
  additionalAnswer = "";
  failureText = "";

  documentation = [];
  documentationName = [];

  success = false;
  finished = false;

  startedProcessJob = null;
  startedProcessJobName = "";

  defectDeadline = "";
}
